export default __webpack_public_path__ + "static/media/address-book.a4dbdacf.svg";